var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-actions"},[(_vm.rowData.approved_at === null)?_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn btn--only-icon-rounded btn--green",on:{"click":function($event){return _vm.approvePersonKpi(_vm.rowData)}}},[_c('i',{staticClass:"far fa-check"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }